import { Model } from "@quest/murka-games-behavior-panther/dist"
import { gameConstants } from "../Constants/gameConstants";

export class BaseGameModel extends Model {
/**
     * Overrided to add the hold 'n' respin feature
     * @param serverModel 
     */
constructor(serverModel: any) {
    super(serverModel)
    this.setAnimationSequence(["stackSymbol", "showAllFrames", "bigWin", "firstToggle", "holdAndReSpinTriggeringAnimation", "holdAndReSpin","triggeringAnimation", "freeSpin", "sendCloseRequest"]);
}

/* @returns If big win is available returns the following - <br>
   ** 0 means no BIG WIN
   ** 1 means BIG WIN, calculated based on multiplier mentioned in `SlotConstants.BigWinMultiplier`
   ** 2 means MEGA BIG WIN calculated based on multiplier mentioned in `SlotConstants.MegaWinMultiplier`
   ** 3 means SUPER BIG WIN calculated based on multiplier mentioned in `SlotConstants.SuperWinMultiplier`
   */
   public getIsBigWin(winAmount: number): number {
    let win = this.getCurrentWinAmt();
    if (winAmount !== undefined) {
      win = winAmount;
    }
    let currBet = this.getTotalBet();
    if (win >= currBet * gameConstants.CrazyWinMultiplier) {
      return 4;
    } else if (win >= currBet * gameConstants.EpicWinMultiplier) {
      return 3;
    } else if (win >= currBet * gameConstants.SuperWinMultiplier) {
      return 2;
    } else if (win >= currBet * gameConstants.BigWinMultiplier) {
      return 1;
    } else {
      return 0;
    }
  }
}

